import script from "./NavMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NavMenu.vue?vue&type=script&setup=true&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=3f84b90a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f84b90a"]])

export default __exports__